export default "__VITE_ASSET__CBuNVq6h__"